import Agreements from '@/views/agreements/agreements.vue'
import NewAgreement from '@/views/agreements/new-agreement.vue'
import NewAgreementForm from '@/views/agreements/new-agreement-form.vue'
import ShowAgreement from '@/views/agreements/show-agreement.vue'
import AgreementMembers from '@/views/agreements/agreement-members.vue'
import AgreementShowBillingInfo from '@/views/agreements/agreement-show-billing-info.vue'
import AgreementMemberSearch from '@/views/agreements/member-search/agreements-members-search.vue'
import { AgreementsRouteNames } from '@/router/routes-names'

export const agreementsRoutes = [
    {
        path: '/agreements',
        name: AgreementsRouteNames.LIST,
        component: Agreements,
        props: true
    },
    {
        path: '/agreements/new',
        name: AgreementsRouteNames.NEW,
        component: NewAgreement
    },
    {
        path: '/agreements/new/form/:organizationId',
        name: AgreementsRouteNames.NEW_FORM,
        component: NewAgreementForm
    },
    {
        path: '/agreements/show/:agreementId',
        name: AgreementsRouteNames.SHOW,
        component: ShowAgreement
    },
    {
        path: '/agreements/members/:agreementId',
        name: AgreementsRouteNames.MEMBERS,
        component: AgreementMembers
    },
    {
        path: '/agreements/billing-info/:agreementId',
        name: AgreementsRouteNames.BILLING_INFO,
        component: AgreementShowBillingInfo
    },
    {
        path: '/agreements/members/search',
        name: AgreementsRouteNames.SEARCH_MEMBERS,
        component: AgreementMemberSearch
    }
]
